import { Button, Card, Container, FloatingLabel, Form } from 'react-bootstrap';
import { useCreateUserWithEmailAndPassword, useUpdateProfile } from 'react-firebase-hooks/auth';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import auth from '../../firebase';
import Loading from '../../Shared/Loading/Loading';
import './SignUp.css';
const SignUp = () => {
    const  navigate = useNavigate();
    const [updateProfile, updating,] = useUpdateProfile(auth);
    const [
        createUserWithEmailAndPassword,
        user,
        loading,
        error,
      ] = useCreateUserWithEmailAndPassword(auth);
    if(loading || updating){
        return <Loading/>
    }
    if(user){
        navigate('/');
    }
    const handleSubmit = async (e)=>{
        e.preventDefault();
        const name = e.target.name.value;
        const email = e.target.email.value;
        const password = e.target.email.value;
        const confirmPassword = e.target.confirmPassword.value;

        if(password !== confirmPassword){

            toast.error("Passwords didn't matched")

        }
         if(email && password){
            
            createUserWithEmailAndPassword(email,password);
            await updateProfile({ displayName: name,});

        }
    }
 return (
    <div className='sign-up'>
        <Container style={{minHeight:'90vh'}} className='d-flex align-items-center justify-content-center'>
            <div className='w-100' style={{maxWidth:'600px'}}>
                    <Card style={{maxWidth:'450px'}} className='p-2 mx-auto'>
                        <Card.Body>
                            <Card.Title>
                                <h3>Sign Up</h3>
                            </Card.Title>
                            <Form onSubmit={handleSubmit} className='my-5'>
                            <FloatingLabel
                                    controlId="formBasicName"
                                    label="Name"
                                    className="mb-3"
                                >
                                    <Form.Control name='name' type="name" placeholder="name@example.com" />
                                </FloatingLabel>
                                <FloatingLabel
                                    controlId="formBasicEmail"
                                    label="Email address"
                                    className="mb-3"
                                >
                                    <Form.Control name='email' type="email" placeholder="name@example.com" />
                                </FloatingLabel>
                                <FloatingLabel
                                    controlId="formBasicPassword"
                                    label="Password"
                                    className="mb-3"
                                >
                                    <Form.Control name='password' type="password" placeholder="Password" />
                                </FloatingLabel>
                                <FloatingLabel
                                    controlId="formBasicPassword"
                                    label="Confirm Password"
                                    className="mb-3"
                                >
                                    <Form.Control name='confirmPassword' type="password" placeholder="Password" />
                                </FloatingLabel>
                                
                                <Button variant="primary" type="submit" className='w-100 fs-5 fw-bold'>Sign Up</Button>
                                <p className='text-center fw-bold my-4'>
                                    Already Have An Account? <Link to='/login'>Login</Link>
                                </p>
                                <p className='text-center text-danger fw-bold'>{error?.message}</p>
                            </Form> 
                        </Card.Body>
                    </Card>
            </div>
            <ToastContainer />
        </Container>
    </div>
 );
};

export default SignUp;